import { render, staticRenderFns } from "./RepeatSendLogsRcpList.vue?vue&type=template&id=3925d994&"
import script from "./RepeatSendLogsRcpList.vue?vue&type=script&lang=js&"
export * from "./RepeatSendLogsRcpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports